"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
// Import colors from CommonJS module
const colorsModule = require("./build/js/mindvalley/colors");
// Re-export colors with proper typing
exports.colors = colorsModule;
// Default export for CommonJS compatibility
exports.default = {
    colors: colorsModule,
};
